import {
  CancelDialogActions,
  ImageCancelDialogLayout,
  CancelModal,
  CancelDialogMessageLayout,
} from '@Components/shared/dialogs/CancelDialog';
import { useCreateRaindrop } from '@Modal/hooks/raindrop/useCreateRaindrop';

export const CreateRaindropCancelModalDialog: React.FC = () => {
  const { handleCancelTakeMeBack, showCancelRaindropForm } = useCreateRaindrop();

  return (
    <>
      {showCancelRaindropForm && (
        <CancelModal open={showCancelRaindropForm}>
          <ImageCancelDialogLayout
            title="Cancel raindrop changes?"
            actions={
              <CancelDialogActions
                onReject={() => handleCancelTakeMeBack('back')}
                onConfirm={() => handleCancelTakeMeBack('')}
              />
            }
          >
            <CancelDialogMessageLayout>
              You are about to delete all the changes you have made in raindrop settings
            </CancelDialogMessageLayout>
          </ImageCancelDialogLayout>
        </CancelModal>
      )}
    </>
  );
};
